import { StringWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-string-widget',
  templateUrl: './string.widget.html'
})
export class MyStringWidgetComponent extends StringWidget {

  showError(errors) {

    const uniqEs6 = (arrArg) => {
      const findArray = [];
      return arrArg.filter((elem) => {
        if (findArray.indexOf(elem.code) >= 0) {
          return false;
        } else {
          findArray.push(elem.code);
          return true;
        }
      });
    };

    return uniqEs6(errors);
  }

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/string/string.widget.ts